<template>
  <div class="container remove-padding-margin">
    <div class="container remove-padding-margin" id="detailkaeyawan">
      <div class="fixed-judul fixed-top">
        <div class="row justify-content-center align-items-center set-row">
          <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
            <img src="../../assets/gambar/back-blue.svg" alt=""/>
          </div>
          <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
            <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">
              Detail Karyawan
            </h6>
          </div>
          <div class="col-md-2 col-sm-2 col-2"></div>
        </div>
      </div>
      <main class="w-limit">
        <div class="text-alignC pad-top-50">
          <div v-if="this.imgBucketUrl === '' || this.imgBucketUrl === null"
               class="upload-file-wrapper mar-top-20 mar-bottom-20">
            <label for="file">
              <img src="../../assets/gambar/Rectangle43.svg" alt=""
                   style="width: 100px;height: 100px;border-radius: 3px;"
                   id="foto">
              <div class="pointer-upload">
                <img src="../../assets/icons/camera1.svg" alt="">
              </div>
            </label>
            <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUpload"
                   accept=".png, .jpg, .jpeg"/>
          </div>
          <div v-else class="upload-file-wrapper mar-top-20 mar-bottom-20">
            <label for="file">
              <figure class="box">
                <img class="imgFit"
                     v-bind:src="this.imgBucketUrl"
                     alt="foto karyawan"
                     id="logo">
              </figure>
              <div class="pointer-upload">
                <img src="../../assets/icons/camera1.svg" alt="">
              </div>
            </label>
            <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUpload"
                   accept=".png, .jpg, .jpeg"/>
          </div>
        </div>
        <div class="flex-100" style="width: 100%">
          <div class="flex-1 pad-top-66">
            <div>
              <div class="font-weight-bold font-16 add-padding-default">
                Data Personal
              </div>
              <div class="row remove-margin card-detail mar-top-16">
                <div
                    class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                >
                  <div class="font-14 text-name color-6f7">Nama Karyawan</div>
                  <div class="text-name font-16">{{ karyawan.nama }}</div>
                </div>
                <div
                    class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                >
                  <span v-if="validateAccess('listEmployees.update')"
                  ><i
                      class="far fa-edit color-206CF"
                      data-toggle="modal"
                      data-target="#modalEname"
                  ></i
                  ></span>
                </div>
              </div>
              <div class="row remove-margin card-detail mar-top-12">
                <div
                    class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                >
                  <div class="font-14 text-name color-6f7">Nomor Telepon</div>
                  <div class="text-name font-16">+{{ karyawan.telp }}</div>
                </div>
                <div
                    class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                >
                  <span v-if="validateAccess('listEmployees.update')"
                  ><i
                      class="far fa-edit color-206CF"
                      data-toggle="modal"
                      data-target="#modalEtelp"
                  ></i
                  ></span>
                </div>
              </div>
              <div class="row remove-margin card-detail mar-top-12">
                <div
                    class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                >
                  <div class="font-14 text-name color-6f7">Alamat</div>
                  <div class="text-name font-16">{{ karyawan.alamat }}</div>
                </div>
                <div
                    class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                >
                  <span v-if="validateAccess('listEmployees.update')"
                  ><i
                      class="far fa-edit color-206CF"
                      data-toggle="modal"
                      data-target="#modalEaddress"
                  ></i
                  ></span>
                </div>
              </div>
              <div class="pembatas remove-margin"></div>

              <div
                  class="data-pekerjan mar-top-15"
                  v-if="
                  this.statusoutlet === 'true' ||
                  this.statusworkshop === 'true' ||
                  this.statuskurir === 'true'
                "
              >
                <div class="font-weight-bold font-16 add-padding-default">
                  Data Pekerjaan
                </div>
                <div
                    class="remove-margin mar-top-16"
                    v-if="this.statusoutlet === 'true'"
                >
                  <div class="add-padding-default border-padbot">
                    <div class="font-16 text-name color-6f7">
                      Bekerja di Outlet
                    </div>
                    <div class="text-name font-16">
                      Outlet {{ this.namaoutlet }}
                    </div>
                  </div>
                </div>
                <div
                    class="remove-margin mar-top-16"
                    v-if="this.statusworkshop === 'true'"
                >
                  <div class="add-padding-default border-padbot">
                    <div class="font-16 text-name color-6f7">
                      Bekerja di Workshop
                    </div>
                    <div class="text-name font-16">
                      Workshop {{ this.namaworkshop }}
                    </div>
                  </div>
                </div>
                <div
                    class="remove-margin mar-top-16"
                    v-if="this.statuskurir === 'true'"
                >
                  <div class="add-padding-default border-padbot">
                    <div class="font-16 text-name color-6f7">
                      Bekerja sebagai
                    </div>
                    <div class="text-name font-16">
                      Kurir
                      <span
                      ><img src="../../assets/icons/mdi_truck.svg"
                      /></span>
                    </div>
                  </div>
                </div>
                <div class="pembatas remove-margin"></div>
              </div>
              <div class="pengaturan">
                <div
                    v-if="validateAccess('listEmployees.account')"
                    class="row remove-margin text-detailO"
                >
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                      @click="gosetakun"
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                    >
                      Pengaturan Akun
                    </div>
                    <div class="font-14 text-name color-6f7">
                      Username & Password untuk login aplikasi
                    </div>
                  </div>
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/chevron-right1.svg"
                        alt=""
                    /></span>
                  </div>
                </div>

                <div
                    v-if="validateAccess('job.read')"
                    class="row remove-margin text-detailO"
                >
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                      @click="
                      isWebview()
                        ? flutterNavigate('karyawan/settings/' + idkaryawan)
                        : gosetwork()
                    "
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                    >
                      Pengaturan Pekerjaan
                    </div>
                  </div>
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/chevron-right1.svg"
                        alt=""
                    /></span>
                  </div>
                </div>
                <div
                    v-if="validateAccess('listEmployees.salary')"
                    class="row remove-margin text-detailO"
                >
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                      @click="gosetgaji"
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                    >
                      Pengaturan Gaji
                    </div>
                  </div>
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/chevron-right1.svg"
                        alt=""
                    /></span>
                  </div>
                </div>
                <div
                    v-if="validateAccess('listEmployees.employeesSalesCommision')"
                    class="row remove-margin text-detailO"
                    @click="gosetsales"
                >
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                    >
                      Pengaturan Komisi Sales
                    </div>
                  </div>
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/chevron-right1.svg"
                        alt=""
                    /></span>
                  </div>
                </div>
                <div
                    v-if="isWebview()"
                    class="row remove-margin text-detailO"
                    @click="flutterNavigate('karyawan/log/' + idkaryawan)"
                >
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                    >
                      Log Aktivitas Karyawan
                    </div>
                  </div>
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/chevron-right1.svg"
                        alt=""
                    /></span>
                  </div>
                </div>
              </div>
              <div class="pembatas remove-margin"></div>
              <div class="logout-hapus">
                <div
                    class="row remove-margin text-detailO"
                    @click="
                    isWebview()
                      ? flutterNavigate('karyawan/force_logout/' + idkaryawan)
                      : gologout()
                  "
                >
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/log-out.svg"
                        alt=""
                    /></span>
                  </div>
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                        style="margin-top: 10px"
                    >
                      Paksa Logout dari aplikasi
                    </div>
                    <div
                        class="font-14 text-name color-6f7"
                        v-if="
                        this.status_wording_kasir == 1 &&
                        this.status_wording_prod == 1
                      "
                        id="logkasirdanproduksi"
                    >
                      Saat ini sedang login di Kasir & Workshop
                    </div>
                    <div
                        class="font-14 text-name color-6f7"
                        v-else-if="
                        this.status_wording_kasir == 1 &&
                        this.status_wording_prod == 0
                      "
                        id="logkasir"
                    >
                      Saat ini sedang login di Kasir
                    </div>
                    <div
                        class="font-14 text-name color-6f7"
                        v-else-if="
                        this.status_wording_prod == 1 &&
                        this.status_wording_kasir == 0
                      "
                        id="logproduksi"
                    >
                      Saat ini sedang login di Workshop
                    </div>
                    <div class="font-14 text-name color-6f7" v-else id="nolog">
                      Belum login
                    </div>
                  </div>
                </div>
                <div
                    class="row remove-margin text-detailO"
                    v-if="validateAccess('listEmployees.delete')"
                    data-toggle="modal"
                    data-target="#modalDelete"
                >
                  <div
                      class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin"
                  >
                    <span
                    ><img
                        class="mar-top-5"
                        src="../../assets/icons/trash-2.svg"
                        alt=""
                    /></span>
                  </div>
                  <div
                      class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin"
                  >
                    <div
                        class="font-16 remove-margin font-colorcheck text-promo"
                        style="margin-top: 10px"
                    >
                      Hapus Karyawan
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="modalEname" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="nav-btn kiri"></div>
                  <h5
                      class="navbar-title text-center text-header-modal color-0000"
                  >
                    Ubah Nama Karyawan
                  </h5>
                  <div class="nav-btn kanan tutup">
                    <img
                        src="../../assets/img/x2.svg"
                        data-dismiss="modal"
                        alt=""
                    />
                  </div>
                </div>
                <div class="modal-body" style="padding: 0px 20px">
                  <form action="">
                    <div class="form-group">
                      <label
                          class="remove-margin font-14 color-8080 mar-top-15 require color-6f7"
                          for="namaDkaryawan"
                      >Nama Karyawan
                      </label>
                      <!--                                            <input type="text" class="form-control inputs font-16 color-0000" id="namaDkaryawan" v-model="editnama"-->
                      <!--                                                   v-on:keyup="inputnama">-->
                      <InputRegular
                          v-model="editnama"
                          :values="editnama"
                          :type="'text'"
                          :id="'namaDkaryawan'"
                          :placeholder="'Sutiaji'"
                          :validationType="'alphanumeric'"
                          :classes="'form-control inputs font-16 color-0000'"
                          ref="inputregular_nama"
                      />
                      <ErrorMessage
                          class="error"
                          label="Nama Karyawan"
                          :validation="$v.editnama"
                      ></ErrorMessage>
                    </div>
                  </form>
                </div>
                <div class="modal-footer" style="padding: 20px 20px">
                  <button
                      type="button"
                      class="btn btn-login btn-long remove-margin"
                      @click="editname"
                  >
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="modalEtelp" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="nav-btn kiri"></div>
                  <h5
                      class="navbar-title text-center require font-14 color-6f7"
                  >
                    Ubah Nomor Telepon Karyawan
                  </h5>
                  <div class="nav-btn kanan tutup">
                    <img
                        src="../../assets/img/x2.svg"
                        data-dismiss="modal"
                        alt=""
                    />
                  </div>
                </div>
                <div class="modal-body remove-padding add-padding-default">
                  <form class="remove-padding" action="">
                    <label for="telpoutlet" class="text-login-wa require"
                    >Nomor Telepon</label
                    >
                    <div class="input-group remove-padding">
                      <vue-country-code
                          @onSelect="onSelect"
                          :preferredCountries="['id', 'my', 'bn']"
                      >
                      </vue-country-code>
                      <input
                          type="tel"
                          class="form-control inputs"
                          id="telpoutlet"
                          placeholder="81757875431"
                          v-on:keyup="nomorWaOnkeyup"
                          v-model="edittelp"
                      />
                    </div>
                    <ErrorMessage
                        class="error"
                        label="Nomor Telepon"
                        :validation="$v.edittelp"
                    ></ErrorMessage>
                  </form>
                </div>
                <div class="modal-footer" style="padding: 20px 20px">
                  <button
                      type="button"
                      class="btn btn-login btn-long remove-margin"
                      id="buttontelp"
                      @click="edittelpp"
                  >
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="modalEaddress" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="nav-btn kiri"></div>
                  <h5 class="navbar-title text-center">Ubah Alamat Karyawan</h5>
                  <div class="nav-btn kanan tutup">
                    <img
                        src="../../assets/img/x2.svg"
                        data-dismiss="modal"
                        alt=""
                    />
                  </div>
                </div>
                <div class="modal-body add-padding-default remove-padding">
                  <form action="">
                    <div class="form-group">
                      <label
                          class="remove-margin font-14 color-6f7 mar-top-16"
                          for="addressDkaryawan"
                      >Alamat Karyawan</label
                      >
                      <input
                          type="text"
                          class="form-control inputs font-16 color-0000"
                          id="addressDkaryawan"
                          v-model="editalamat"
                          v-on:keyup="editaddress"
                      />
                      <ErrorMessage
                          class="error"
                          label="Alamat"
                          :validation="$v.editalamat"
                      ></ErrorMessage>
                    </div>
                  </form>
                </div>
                <div class="modal-footer" style="padding: 20px 20px">
                  <button
                      type="button"
                      class="btn btn-login btn-long remove-margin"
                      @click="editalamatt"
                  >
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="modalDelete" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="nav-btn kiri"></div>
                  <h5 class="navbar-title text-center">Hapus Karyawan</h5>
                  <div class="nav-btn kanan tutup">
                    <img
                        src="../../assets/img/x2.svg"
                        data-dismiss="modal"
                        alt=""
                    />
                  </div>
                </div>
                <div class="modal-body">
                  <div>
                    Apakah Anda yakin ingin menghapus karyawan
                    <b>{{ karyawan.nama }}</b>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-outline-hapus btn-long"
                      data-dismiss="modal"
                      @click="deletestafff"
                  >
                    Ya,Hapus
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="modalmaintance" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="nav-btn kiri"></div>
                  <h5 class="navbar-title text-center">Under Maintance</h5>
                  <div class="nav-btn kanan tutup">
                    <img
                        src="../../assets/img/x2.svg"
                        data-dismiss="modal"
                        alt=""
                    />
                  </div>
                </div>
                <div class="modal-body">
                  <div class="font-weight-bold color-206CF">
                    Under Maintance
                  </div>
                </div>
                <div class="modal-footer remove-mar-lr">
                  <div style="margin-right: 0px">
                    <button
                        type="button"
                        class="btn btn-outline-primary btn-long"
                        data-dismiss="modal"
                    >
                      UNDER MAINTANCE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <AkunSet
        v-bind:class="{ hidesection: !issetakun }"
        v-on:isdetail="isdetail"
        v-bind:setidkaryawan="idkaryawan"
        ref="getakun"
    />
    <WorkSet
        v-bind:class="{ hidesection: !issetwokset }"
        v-on:isdetail="isdetailfromworkset"
        v-bind:setidkaryawan="idkaryawan"
        ref="getdetailpekerjaan"
    />
    <ActivationCommision
        v-bind:class="{ hidesection: !issetsales }"
        v-on:isdetail="isdetailfromsalesset"
        v-bind:setidkaryawan="idkaryawan"
        ref="getchoicekomisi"
    />
    <SallarySet
        v-bind:class="{ hidesection: !issetgaji }"
        v-on:isdetail="isdetailfromgaji"
        ref="getdatagaji"
        v-bind:setidkaryawan="idkaryawan"
    />
    <LogouPage
        v-bind:class="{ hidesection: !issetlogout }"
        v-on:isdetail="isdetailfromlogout"
        v-bind:setidkaryawan="idkaryawan"
        ref="getdetailkaryawanlogout"
    />
  </div>
</template>

<script>
import AkunSet from "./AkunSet";
import WorkSet from "./WorkSet";
import ActivationCommision from "./ActivationCommision";
import SallarySet from "./SallarySet";
import LogouPage from "./LogouPage";
import InputRegular from "../../component-items/InputRegular";
import ErrorMessage from "@/component-items/ErrorMessage";
import {maxLength, minLength, required} from "vuelidate/lib/validators";

export default {
  name: "DetailKaryawan",
  components: {
    AkunSet,
    WorkSet,
    ActivationCommision,
    SallarySet,
    LogouPage,
    InputRegular,
    ErrorMessage,
  },
  data() {
    return {
      issetakun: false,
      issetwokset: false,
      issetsales: false,
      issetgaji: false,
      issetlogout: false,
      isClicked: false,
      idkaryawan: "",
      karyawan: {},
      editnama: "",
      telpCode: "",
      edittelp: "",
      editalamat: "",
      foto: "",
      namaoutlet: "",
      namaworkshop: "",
      statusworkshop: "false",
      statusoutlet: "false",
      statuskurir: "false",
      status_wording_kasir: 0,
      status_wording_prod: 0,
      requestHeaders: {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      },
      bucketUrl: 'https://storage.googleapis.com',
      imgBucketUrl: '',
    };
  },
  props: ["datadetailkaryawan", "parentidkaryawan"],
  mounted() {
    this.idkaryawan = this.$route.params.idkaryawan;
    if (this.idkaryawan === "") {
      this.getdetailkaryawan();
      // if (process.env.NODE_ENV !== "production") {
      //   this.imgBucketSrc = this.bucketUrl.ages
      // } else {
      //   this.imgBucketSrc = this.bucketUrl.dalbo
      // }
    }
    $("#close").hide();
  },
  validations: {
    editnama: {
      required,
      minLength: minLength(2),
    },
    edittelp: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(12),
    },
    editalamat: {
      required,
      minLength: minLength(2),
    },
  },
  methods: {
    back() {
      this.$emit("showkaryawanlist");
    },
    onSelect({name, iso2, dialCode}) {
      this.telpCode = dialCode;
    },
    handleFileUpload() {
      this.fotokaryawan = this.$refs.file.files[0];
      const FileSize = this.$refs.file.files[0].size / 1024 / 1024;
      const validator = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
      if (FileSize > 2) {
        this.$toast.error('File Gambar tidak boleh lebih dari 2 MB, file anda ' + FileSize.toFixed(2) + ' MB')
        $('#file').val("");
        if (this.fotokaryawan === null) {
          $('.logo').attr('src', '/img/Rectangle43.b88d5998.svg');
        } else {
          $('.logo').attr('src', this.fotokaryawan);
        }
      } else {
        let blnValid = false;
        for (let j = 0; j < validator.length; j++) {
          const sCurExtension = validator[j];
          if (this.fotokaryawan.name.substr(this.fotokaryawan.name.length - sCurExtension.length, sCurExtension.length).toLowerCase() === sCurExtension.toLowerCase()) {
            blnValid = true;
          }
        }
        if (!blnValid) {
          this.$toast.error('File photo harus menggunakan format jpg, jpeg, dan png')
        } else {
          $('#logo').attr('src', URL.createObjectURL(this.$refs.file.files[0]));
          this.updatepicture()
        }
      }
    },
    async updatepicture() {
      $('#loadingPage').addClass('overlayLoading');
      $('#loadingPage').show();
      try {
        const updatedata = new FormData()
        updatedata.append('media', this.fotokaryawan)
        const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/update_foto_karyawan/' + this.idkaryawan, updatedata, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        })
        if (response.data.status === true) {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide();
          this.getdetailkaryawan();
          this.$toast.success(response.data.msg)
        } else {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide()
          this.$toast.error(response.data.msg)
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },
    onboardingFinishToDashboard() {
      var self = this;
      const tour = new Shepherd.Tour({
        defaultStepOptions: {
          scrollTo: {
            behavior: "smooth",
            block: "center",
          },
          // beforeShowPromise: function () {
          //     return new Promise(function (resolve) {
          //         setTimeout(function () {
          //             resolve();
          //         }, 700)
          //     });
          // }
        },
        useModalOverlay: true,
      });

      tour.addSteps([
        {
          classes: "figure fig-clock",
          title: "Selamat! Data anda sudah siap",
          text: "<p>Data Anda <b>sudah siap</b> untuk mulai menjalankan bisnis dengan sistem smartlink</p>",
          buttons: [
            {
              classes: "shp-btn-right to-dashboard",
              text: "Lihat Dashboard",
            },
          ],
          beforeShowPromise: function () {
            return new Promise(function (resolve) {
              resolve();
            });
          },
        },
      ]);

      setTimeout(() => {
        $(".to-dashboard").click(function () {
          tour.cancel();
          self.$router.push("/dashboard");
        });
      }, 500);

      tour.start();
    },
    isdetail() {
      $("#detailkaeyawan").show();
      this.issetakun = false;
      this.getdetailkaryawan();
      this.backButtonPressed(this.back);
    },
    isdetailfromworkset() {
      $("#detailkaeyawan").show();
      this.issetwokset = false;
      this.getdetailkaryawan();
    },
    isdetailfromsalesset() {
      $("#detailkaeyawan").show();
      this.issetsales = false;
      this.getdetailkaryawan();
    },

    isdetailfromgaji() {
      $("#detailkaeyawan").show();
      this.issetgaji = false;
      this.getdetailkaryawan();
    },

    isdetailfromlogout() {
      $("#detailkaeyawan").show();
      this.issetlogout = false;
      this.getdetailkaryawan();
    },
    gologout(idkaryawan) {
      this.smartTrackingClick("force_logout_karyawan", {
        idkaryawan: idkaryawan,
      });

      this.$refs.getdetailkaryawanlogout.getdetailkaryawanlogout(idkaryawan);
      $("#isikasir").hide();
      $("#isiproduksi").hide();
      $("#kosongproduksi").hide();
      $("#kosongkasir").hide();
      $("#detailkaeyawan").hide();
      this.issetlogout = true;
      this.backButtonPressed(this.$refs.getdetailkaryawanlogout.back);
    },
    setid(idkaryawan) {
      this.idkaryawan = idkaryawan;
      this.getdetailkaryawan();
    },
    gosetwork(idkaryawan) {
      this.smartTrackingClick("pengaturan_pekerjaan_karyawan", {
        idkaryawan: idkaryawan,
      });
      $("#closeD").hide();
      $("#contentoutlet").hide();
      $("#contentworkshop").hide();
      $("#content-kasir").hide();
      this.$refs.getdetailpekerjaan.listoutlet();
      this.$refs.getdetailpekerjaan.getWorkshop();
      this.issetakun = false;
      this.issetsales = false;
      this.issetwokset = true;
      $("#detailkaeyawan").hide();
      this.$refs.getdetailpekerjaan.getdetailpekerjaan(idkaryawan);
      this.backButtonPressed(this.$refs.getdetailpekerjaan.back);
    },
    gosetgaji(idkaryawan) {
      this.smartTrackingClick("pengaturan_gaji_karyawan", {
        idkaryawan: idkaryawan,
      });
      this.issetakun = false;
      this.issetsales = false;
      this.issetwokset = false;
      this.issetgaji = true;
      $("#detailkaeyawan").hide();
      this.$refs.getdatagaji.getdatagaji(idkaryawan);
      this.backButtonPressed(this.$refs.getdatagaji.back);
    },
    gosetsales(idkaryawan) {
      this.smartTrackingClick("pengaturan_komisi_karyawan", {
        idkaryawan: idkaryawan,
      });
      // this.$router.push({name: 'activationcommision', params: {idkaryawan: this.idkaryawan}})
      this.issetakun = false;
      this.issetsales = true;
      this.issetwokset = false;
      $("#detailkaeyawan").hide();
      // $('#worksetpage').hide();
      this.$refs.getchoicekomisi.getchoicekomisi(idkaryawan);
      this.$refs.getchoicekomisi.getaktifkomisi(idkaryawan);
      this.backButtonPressed(this.$refs.getchoicekomisi.back);
    },
    gosetakun(idkaryawan) {
      this.smartTrackingClick("pengaturan_akun_karyawan", {
        idkaryawan: idkaryawan,
      });
      this.issetakun = true;
      this.issetsales = false;
      this.issetwokset = false;
      $("#detailkaeyawan").hide();
      this.$refs.getakun.getakun(idkaryawan);
      this.backButtonPressed(this.$refs.getakun.back);
    },

    async getdetailkaryawan() {
      this.smartTrackingView("detail_karyawan");

      this.namaworkshop = "";
      this.namaoutlet = "";
      this.statusoutlet = "false";
      this.statusworkshop = "false";
      this.statuskurir = "false";
      if (!this.idkaryawan) {
        this.idkaryawan = this.parentidkaryawan;
      }
      $("#loadingPage").addClass("overlayLoading");
      $("#loadingPage").show();
      try {
        const response = await this.$axios.get(
            this.$baseurl +
            "/masterData/meta/detail_karyawan_meta?idkaryawan=" +
            this.idkaryawan,
            this.requestHeaders
        );
        this.karyawan = response.data.data;
        if (response.status === 200) {
          if (response.data.status === true) {
            var res = response.data.data;
            this.editnama = res.nama;
            //this.edittelp = res.telp;
            this.editalamat = res.alamat;
            this.idkaryawan = res.idkaryawan;
            this.nomorWaOnkeyup();
            var dataLog = response.data.log_token;

            if (res.daftar_karyawan_outlet != null) {
              this.namaoutlet = res.daftar_karyawan_outlet.outlet.nama;
              this.statusoutlet = "true";
            }
            if (res.daftar_karyawan_workshop != null) {
              this.namaworkshop = res.daftar_karyawan_workshop.workshop.nama;
              this.statusworkshop = "true";
            }

            if (res.daftar_karyawan_kurir != null) {
              this.statuskurir = "true";
            }

            if (res['transaksi_foto'] != null) {
              const transaksi_foto = res['transaksi_foto'];
              this.imgBucketUrl = `${this.bucketUrl}/${transaksi_foto['cloud_bucket']}/${transaksi_foto['cloud_name']}`;
            }else{
              this.imgBucketUrl = '';
            }

            if (dataLog.length > 0) {
              for (var i = 0; i < dataLog.length; i++) {
                if (dataLog[i].idaplikasi === 1) {
                  if (dataLog[i].valid === 1) {
                    this.status_wording_kasir = 1;
                  }
                }

                if (dataLog[i].idaplikasi === 2) {
                  if (dataLog[i].valid === 1) {
                    this.status_wording_prod = 1;
                  }
                }
              }
            } else {
              $("#logkasir").hide();
              $("#logkasirdanproduksi").hide();
              $("#logproduksi").hide();
              $("#nolog").show();
            }
            $("#loadingPage").removeClass("overlayLoading");
            $("#loadingPage").hide();
          }
        }
      } catch (e) {
        $("#loadingPage").removeClass("overlayLoading");
        $("#loadingPage").hide();

        this.$catch_error_response(e);
      }
    },

    async editname() {
      if (this.$v.editnama.$invalid) {
        this.$v.editnama.$touch();
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      this.isClicked = true;
      $("#loadingPage").addClass("overlayLoading");
      $("#loadingPage").show();
      try {
        const editname = new FormData();
        editname.append("nama_karyawan", this.editnama);
        const response = await this.$axios.post(
            this.$baseurl +
            "/masterData/karyawan/update_nama_karyawan?idkaryawan=" +
            this.idkaryawan,
            editname,
            this.requestHeaders
        );
        if (response.data.status === true) {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();

          this.getdetailkaryawan();

          this.$toast.success(response.data.msg);
          $("#modalEname").modal("hide");
        } else {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();

          this.$toast.error(response.data.msg);
        }
      } catch (e) {
        $("#loadingPage").removeClass("overlayLoading");
        $("#loadingPage").hide();

        this.$catch_error_response(e);
      }
    },

    async edittelpp() {
      if (this.$v.edittelp.$invalid) {
        this.$v.edittelp.$touch();
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      // this.isClicked = true;
      $("#loadingPage").addClass("overlayLoading");
      $("#loadingPage").show();
      try {
        const edittelp = new FormData();
        edittelp.append("telepon_karyawan", this.telpCode + this.edittelp);
        const response = await this.$axios.post(
            this.$baseurl +
            "/masterData/karyawan/update_telepon_karyawan?idkaryawan=" +
            this.idkaryawan,
            edittelp,
            this.requestHeaders
        );
        if (response.data.status === true) {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();

          this.getdetailkaryawan();

          this.$toast.success(response.data.msg);
          $("#modalEtelp").modal("hide");
        } else {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();

          this.$toast.error(response.data.msg);
        }
      } catch (e) {
        $("#loadingPage").removeClass("overlayLoading");
        $("#loadingPage").hide();

        this.$catch_error_response(e);
      }
    },

    async editalamatt() {
      if (this.$v.editalamat.$invalid) {
        this.$v.editalamat.$touch();
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      // this.isClicked = true;
      $("#loadingPage").addClass("overlayLoading");
      $("#loadingPage").show();
      try {
        const editaddress = new FormData();
        editaddress.append("alamat_karyawan", this.editalamat);
        const response = await this.$axios.post(
            this.$baseurl +
            "/masterData/karyawan/update_alamat_karyawan?idkaryawan=" +
            this.idkaryawan,
            editaddress,
            this.requestHeaders
        );
        if (response.data.status === true) {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();
          this.getdetailkaryawan();

          this.getdetailkaryawan();

          this.$toast.success(response.data.msg);
          $("#modalEaddress").modal("hide");
        } else {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();

          this.$toast.error(response.data.msg);
        }
      } catch (e) {
        $("#loadingPage").removeClass("overlayLoading");
        $("#loadingPage").hide();

        this.$catch_error_response(e);
      }
    },

    async deletestafff() {
      try {
        const deletestaff = new FormData();
        const response = await this.$axios.post(
            this.$baseurl +
            "/masterData/karyawan/delete_karyawan?idkaryawan=" +
            this.idkaryawan,
            deletestaff,
            this.requestHeaders
        );
        if (response.status === 200) {
          if (response.data.status === true) {
            this.back();
            this.$toast.success(response.data.msg);

            this.getdetailkaryawan();
          } else {
            this.$toast.error(response.data.msg);
          }
        }
      } catch (e) {
        $("#loadingPage").removeClass("overlayLoading");
        $("#loadingPage").hide();

        this.$catch_error_response(e);
      }
    },

    nomorWaOnkeyup() {
      var phoneField = this.edittelp;
      var frstCar = phoneField.substring(0, 1);
      var firstTel = phoneField.substring(1, 15);
      var secCar = phoneField.substring(0, 2);
      var secTel = phoneField.substring(2, 15);
      var thrdcar = phoneField.substring(0, 14);
      var output;

      if (frstCar == 0) {
        output = firstTel;
      } else if (secCar == this.telpCode) {
        output = secTel;
      } else {
        output = thrdcar;
      }
      var number = output.replace(/[^0-9]+/, "");

      var charLenght = number.length;
      if (charLenght >= 8 && charLenght <= 13) {
        // $('#buttontelp').prop('disabled', false);
      } else {
        // $('#buttontelp').prop('disabled', true);
      }
      this.edittelp = number;
    },

    inputnama(event) {
      var nums = event.target.value;
      var number = nums.replace(/[^0-9A-Za-z_.,' -]+/, "");
      this.editnama = number;
    },
    editaddress(event) {
      var nums = event.target.value;
      var number = nums.replace(/[^0-9A-Za-z_.,' -]+/, "");
      this.editalamat = number;
    },
  },
};
</script>

<style scoped>
.text-name {
  line-height: 21px;
  align-items: center;
  letter-spacing: -0.02em;
}

.new-color {
  color: #808080;
}

.text-detailO {
  border-bottom: 1px solid #ededed;
  padding: 16px 20px 12px;
}

.text-header-modal {
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  margin-bottom: 4px;
}

.hidesection {
  display: none;
}

.btn-outline-hapus {
  color: #eb5757;
  border-color: #eb5757;
}

.border-padbot {
  border-bottom: 1px solid #ededed;
  padding-bottom: 12px;
}

.card-detail {
  border-bottom: 1px solid #ededed;
  padding: 0px 20px 12px;
}


.input-upload {
  display: none;
}

.box {
  width: 95.53px;
  height: 95.53px;
}

.imgFit {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
  margin-top: 2px;
}


.pointer-upload {
  display: flex;
  width: 33px;
  height: 33px;
  border-radius: 4px;
  background: #206CFF;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  animation: pulse 2s infinite;
  align-content: center;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* bottom: 70px; */
  right: -15px;
  bottom: -15px;
}


.upload-file-wrapper {
  width: 100px;
  height: 100px;
  margin: 20px auto;
  border: 1px solid rgba(0, 0, 0, 0.15);
  position: relative;
}

</style>
